import { TranslatePipe } from '../../filters/translate.pipe';
import { AvatarComponent } from '../../components/avatar/avatar.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ServiceRestServices from '../../services/service-rest.service';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import ChatRestServices from '../../services/chat-rest.service';
import WordCloudService from '../../services/word-cloud.service';
import UrlUtil from '../../utils/url-util.service';
import LanguageService from '../../services/language.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';
import DialogServices from '../../services/dialog.service';
import { ModalNotificationComponent } from '../../components/modal-notification/modal-notification.component';

@Component({
	standalone: true,
	selector: 'booking-intermediate-dialog',
	templateUrl: './booking-intermediate-dialog.component.html',
	imports: [ CommonModule, TranslatePipe, AvatarComponent, FormsModule ]
})
export default class BookingIntermediateDialogView implements OnInit {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private wordCloudService: WordCloudService = inject(WordCloudService);
	private urlUtil: UrlUtil = inject(UrlUtil);
	private languageService: LanguageService = inject(LanguageService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	private dialogServices: DialogServices = inject(DialogServices);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.isProcessing = true;
		this.routingService.validateAccess('booking').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.loadBasicData();
		
		this.vm.getConsultantName = this.getConsultantName;
		this.vm.openItemDescription = this.openItemDescription;
		this.vm.removeSelectedItem = this.removeSelectedItem;
		this.vm.startCommunicationChat = this.startCommunicationChat;
		this.vm.redirectToBooking = this.redirectToBooking;
		
		this.vm.answers = [];
		var params: any = this.angularRoutingHelperService.getQueryParams();
		this.vm.selectedItems = Array.isArray(params['selectedItem']) ? params['selectedItem'] : [params['selectedItem']];
		this.vm.primaryLanguage = params['primaryLanguage'];
		this.vm.problem = params['problem'];
		this.vm.isPreVisit = params['type'] === 'pre-visit';
		this.vm.serviceId = params['serviceId'];
		this.vm.isOutOfHoursMode = !!params['serviceId'];
		this.vm.user = this.session.getSession().user;
		this.vm.origin = this.vm.user.origin;
		
		if (this.vm.isOutOfHoursMode) {
			this.serviceRestServices.getServiceById({ id: this.vm.serviceId }, (service) => {
				this.vm.consultant = service.user;
			});
		} else {
			this.chatRestServices.getConsultant({ primaryLanguage: this.vm.primaryLanguage }, (response) => {
				this.vm.consultant = response.user;
				this.vm.isChatBotEnabled = response.chatBotEnabled;
			});
		}
		
		this.wordCloudService.getQuestionnaire().then((questionnaire) => {
			this.vm.questionnaireId = questionnaire.id;
			questionnaire.questions[0]['answers']
				.filter((answer) => {
					return this.vm.selectedItems.map(function(v) { return v.toString() }).indexOf(answer.id.toString()) !== -1
				})
				.map((answer) => {
					this.vm.answers.push({
						id: answer.id,
						defaultText: answer.defaultText,
						text: answer.translation['translationText']
					});
				});
			this.vm.isProcessing = false;
		});
		
		this.languageService.getLanguageRatings().subscribe((response: any) => {
			response.forEach((language) => {
				this.vm.languageMap[language.languageCode] = language.name;
			});
		});
		
		this.languageService.incrementLanguageUsageRating(this.vm.primaryLanguage).subscribe(() => {
			console.log('Language rating ' + this.vm.primaryLanguage + ' incremented');
		});
	}
	
	loadBasicData() {
		this.vm.languageMap = {};
		
		this.vm.descriptionMappings = {
			'en': {
				'Sleeping problems': '/sleeping',
				'Pain': '/chronic-pain',
				'Addiction': '/addiction',
				'Worrying': '/worrying',
				'Sadness': '/sadness',
				'Relationship problems': '/relationship',
				'Loneliness': '/loneliness',
				'Lowered self esteem': '/self-esteem',
				'Anxiety': '/anxiety'
			},
			'et': {
				'Sleeping problems': '/uneprobleemid',
				'Pain': '/krooniline-valu',
				'Addiction': '/soltuvused',
				'Worrying': '/muretsemine',
				'Sadness': '/kurbus',
				'Relationship problems': '/suhteprobleemid',
				'Loneliness': '/uksindus',
				'Lowered self esteem': '/enesehinnang',
				'Anxiety': '/arevus'
			},
			'ru': {
				'Sleeping problems': '/problemi-so-snom',
				'Pain': '/hronicheskaja-bol',
				'Addiction': '/zavisimost',
				'Worrying': '/bespokoistvo',
				'Sadness': '/pechal',
				'Relationship problems': '/problemi-otnoshenij',
				'Loneliness': '/odinochestvo',
				'Lowered self esteem': '/samoocenka',
				'Anxiety': '/trevozhnost'
			},
			'fi': {
				'Sleeping problems': '/nukkumassa',
				'Pain': '/krooninen-kipu',
				'Addiction': '/riippuvuus',
				'Worrying': '/huolestuttava',
				'Sadness': '/surullisuus',
				'Relationship problems': '/suhde',
				'Loneliness': '/yksinaisyys',
				'Lowered self esteem': '/itsetunto',
				'Anxiety': '/ahdistus'
			}
		};
	}
	
	getConsultantName() {
		var consultant: any = this.vm.consultant;
		if (consultant && consultant.id) {
			return consultant.firstname + ' ' + consultant.lastname;
		} else {
			return '';
		}
	}
	
	openItemDescription($event, item) {
		if (this.vm.user.origin == 'siffi.com') {
			var path: any = '/problem-description' + this.vm.descriptionMappings['en'][item.defaultText];
			var locale: any = (this.vm.user && this.vm.user.deviceLanguage) || 'en_GB';
			var url: any = this.config.getSiffiPublicWebUrl(locale, path);
			this.angularHelperService.getWindow().open(url, '_blank');
		} else {
			var url: any = this.urlUtil.createPublicUrl({
				et_EE: '/probleemi-kirjeldus' + this.vm.descriptionMappings['et'][item.defaultText],
				en_GB: '/problem-description' + this.vm.descriptionMappings['en'][item.defaultText],
				fi_FI: '/ongelman-kuvaus' + this.vm.descriptionMappings['fi'][item.defaultText],
				ru_RU: '/opisaniye-problemy' + this.vm.descriptionMappings['ru'][item.defaultText]
			});
			this.angularHelperService.getWindow().open(url, '_blank');
		}
	}
	
	removeSelectedItem($event, item) {
		this.vm.answers = this.vm.answers.filter(function(answer) {
			return answer.id !== item.id
		});
	}
	
	startCommunicationChat() {
		if (this.vm.submitInProgess) {
			return;
		}
		this.vm.submitInProgess = true;
		var problems: any = this.vm.answers.map(function(item) {
			return item.defaultText;
		});
		
		var submitQuestionnairePromise: any = this.serviceRestServices.submitQuestionnaireAnswers(
			{ questionnaireId: this.vm.questionnaireId, language: (this.vm.user.deviceLanguage || 'et_EE') },
			this.vm.answers.map(function(answer) {
				return { id: answer.id }
			}));
		
		var chatData: any = {
			primaryLanguage: this.vm.primaryLanguage,
			content: this.generateMessage(problems, this.vm.primaryLanguage, this.vm.problem)
		};
		if (this.vm.isPreVisit) {
			var submitChatMessagePromise: any = this.chatRestServices.sendPostToConsultant({ isPreVisit: this.vm.isPreVisit }, chatData);
		} else {
			var submitChatMessagePromise: any = this.chatRestServices.sendPostToConsultant({}, chatData);
		}
		
		this.angularHelperService.getPromise().all([submitQuestionnairePromise, submitChatMessagePromise])
			.then((result) => {
				this.angularHelperService.createTimer(() => {
					this.angularRoutingHelperService.clearQueryParamsDirty()
					this.angularRoutingHelperService.setPath('/chats/' + result[1][0].chat.id);
				}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
			});
	}
	
	redirectToBooking() {
		var submitQuestionnairePromise: any = this.serviceRestServices.submitQuestionnaireAnswers(
			{ questionnaireId: this.vm.questionnaireId, language: (this.vm.user.deviceLanguage || 'et_EE'), scheduledBookingWordCloud: true },
			this.vm.answers.map(function(answer) {
				return { id: answer.id }
			}));
		var createFakeBookingPromise: any = this.serviceRestServices.createFakeBooking({});
		this.angularHelperService.getPromise().all([submitQuestionnairePromise, createFakeBookingPromise])
		.then((result) => {
			this.angularRoutingHelperService.setPath('/booking/service/' + this.vm.serviceId, false, false, { skipRedirectCheck: true });
		});
	}
	
	openChatBotInfo() {
		this.dialogServices.show({
			controller: ModalNotificationComponent,
			text: this.angularFilterHelperService.translate('Chats.Other.Ai_Chat_Disclaimer'),
		});
	}
	
	generateMessage(tags, language, description) {
		var initialMessage: any = 'Service language: ' + this.vm.languageMap[language || 'en'];
		var message: any = initialMessage + '. ';
		if ((tags || []).length > 0) {
			message += (tags.join(', ') + '. ');
		}
		return message + ((description || '').trim());
	}
	
}
